export default __webpack_public_path__ + "static/media/light-survey.9787a13c.png";